// extracted by mini-css-extract-plugin
export var label = "_5-2";
export var logo = "_5-1";
export var topNav = "_5-0";